module.exports = __webpack_public_path__ + "img/firewall.a9d34cd.svg";